import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { Subscription } from "rxjs";

import Swal from "sweetalert2";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "../../../core/service/auth.service";
import { RestClientService } from "../../../core/service/rest-client.service";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { NgSelectModule } from "@ng-select/ng-select";
import { BenefInfoComponent } from "../benef-info/benef-info.component";
import { FileUploadComponent } from "../file-upload/file-upload.component";
import * as _ from 'lodash';


@Component({
  selector: 'app-scroll-search-medoc-presta',
  standalone: true,
    imports: [CommonModule, NgSelectModule,FormsModule,BenefInfoComponent,
      MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        FileUploadComponent,
        MatCheckboxModule,
        MatRadioModule,
        MatDatepickerModule,
        MatButtonModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        MatSlideToggleModule,
  ],
  templateUrl: './scroll-search-medoc-presta.component.html',
  styleUrl: './scroll-search-medoc-presta.component.css'
})
export class ScrollSearchMedocPrestaComponent {

  items: Array<any> = [];
  user: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  busyGet!: Subscription;
  searchKeyMedoc: any = "";
  // medicament:any={}
  medicament:any= null; 
  // prestataire_id:any
  @Input() current_medicament_id: any;
  @Input() clearText: any;
  @Input() reload: any;
  @Output() onSelectMedoc = new EventEmitter();
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    
  }

  ngOnChanges(changes: SimpleChanges) {
    
    // if (changes.type_prestataire_id && changes.type_prestataire_id.currentValue) {
    //   this.type_prestataire_id = changes.type_prestataire_id.currentValue;
    // }
    // if (changes.reseau_de_soin_id && changes.reseau_de_soin_id.currentValue) {
    //   this.reseau_de_soin_id = changes.reseau_de_soin_id.currentValue;
    // }
    // if (changes.current_prestataire_id && changes.current_prestataire_id.currentValue) {
    //   this.prestataire_id = changes.current_prestataire_id.currentValue;
    // }
    console.log('changes: ',changes)
    if (changes["clearText"] && changes["clearText"].currentValue) {
      this.clearSelection()
    }
    if (changes["reload"] && !changes["clearText"]) {
      this.clearSelection()
    }
    this.itemsPerPage=10
    this.getItems()
  }
  onSearch(event:any) {
    console.log("fkdkfjkd", event);
    this.itemsPerPage = 10;
    this.searchKeyMedoc = event.term;
    if(event.term.length)
      this.getItems();
    else{
    this.onSelectMedoc.emit({})

    }
  }

  clearSelection() {
    this.current_medicament_id = null; // or undefined
    this.items=[]
    this.searchKeyMedoc = ''
    // this.medicament={}
    this.medicament=null
    this.onSelectElement()
  }
  

  onGetMoreItems() {
    this.itemsPerPage += 5;
    this.getItems();
  }


  onSelectElement(){

    this.onSelectMedoc.emit(this.medicament)
    

  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: this.itemsPerPage,
      search_key: this.searchKeyMedoc,
      data: {
        current_medicament_id: this.current_medicament_id,

      },
    };

    this.busyGet = this.restClient
      .post("medicament/getByCriteria", request)
      .subscribe(
        (res:any) => {
          if (res && res["items"]) {
            this.items = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.items = [];
          }
        },
        (err) => {
          this.items = [];
        }
      );
  }
  


  onSelectTypePrestataire() {}

  ngOnInit() {
  }


}
